import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryTitleComponent } from './story-title.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

const ANGULAR_MATERIAL_MODULES = [MatTooltipModule, MatIconModule];

const COMPONENTS = [StoryTitleComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule, ...ANGULAR_MATERIAL_MODULES
  ],
  exports: [...COMPONENTS]
})
export class StoryTitleModule { }
